import { render } from "./BaseButtonNegative.vue?vue&type=template&id=34902de5"
import script from "./BaseButtonNegative.vue?vue&type=script&lang=js"
export * from "./BaseButtonNegative.vue?vue&type=script&lang=js"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__